// Common computation utilities shared across all ROB Survey tabs.
// Tab-specific computations live in each tab's computations/ folder.

// ─── Shared helper ────────────────────────────────────────────────────────────

/**
 * Parses a "DD.MM.YYYY HH:mm" string into a Date object.
 */
const parseTimestamp = str => {
  const [datePart, timePart] = str.split(' ')
  const [dd, mm, yyyy] = datePart.split('.')
  const [hh, min] = timePart.split(':')

  return new Date(+yyyy, +mm - 1, +dd, +hh, +min)
}

// ─── Survey Log: Total Hours on Board ────────────────────────────────────────
//   boardedStr / leftStr format: "DD.MM.YYYY HH:mm"

export const computeTotalHoursOnBoard = (boardedStr, leftStr) => {
  try {
    const diffMs = parseTimestamp(leftStr) - parseTimestamp(boardedStr)
    if (diffMs <= 0) return '—'
    const totalMinutes = Math.floor(diffMs / 60000)
    const h = Math.floor(totalMinutes / 60)
    const m = totalMinutes % 60

    return `${h}h ${String(m).padStart(2, '0')}m`
  } catch {
    return '—'
  }
}
